import { AfterViewInit, Component, ElementRef, OnDestroy, computed, effect, inject, signal, ViewChild, ViewContainerRef, PendingTasks, DestroyRef, ComponentRef } from '@angular/core';
import { RouterLink } from '@angular/router';
import { I18nService } from '../../core/i18n.service';
import { PageDataService } from '../../core/page-data.service';
import { AymoMotionComponent } from '../aymo/aymo-motion.component';

@Component({
  selector: 'app-aymudo-modern-home',
  imports: [RouterLink, AymoMotionComponent],
  template: `
    <main class="modern-home">
      <section [style.order]="sectionOrder('hero')" [style.display]="sectionHidden('hero') ? 'none' : null" data-landing-section="hero" class="hero">
        <div class="hero-copy">
          <p data-landing-key="eyebrow">{{ copy().eyebrow }}</p>
          <h1 data-landing-key="title">{{ copy().title }}</h1>
          <span data-landing-key="lead">{{ copy().lead }}</span>
          <nav>
            <a class="primary" [routerLink]="i18n.routePath('subscribe')">{{ copy().subscribe }}</a
            ><a [routerLink]="i18n.routePath('whyAymudo')">{{ copy().discover }} <b>→</b></a>
          </nav>
          @if (i18n.contentLang() === 'tr') {
            <div class="hero-service-shortcuts" aria-label="Yönetilen işletme hizmetleri">
              <a routerLink="/hizmetler/uzaktan-sekreterlik"><small data-landing-key="fixed.1">{{ landingText('fixed.1', "İnsan desteği") }}</small><strong data-landing-key="fixed.2">{{ landingText('fixed.2', "Uzaktan sekreterlik") }}</strong></a>
              <a routerLink="/hizmetler/mesaj-cevaplama"><small data-landing-key="fixed.3">{{ landingText('fixed.3', "AI + onay") }}</small><strong data-landing-key="fixed.4">{{ landingText('fixed.4', "Mesaj cevaplama") }}</strong></a>
              <a routerLink="/hizmetler/reklam-yonetimi"><small data-landing-key="fixed.5">{{ landingText('fixed.5', "Meta · Google") }}</small><strong data-landing-key="fixed.6">{{ landingText('fixed.6', "Reklam yönetimi") }}</strong></a>
              <a routerLink="/hizmetler/sosyal-medya-yonetimi"><small data-landing-key="fixed.7">{{ landingText('fixed.7', "İçerik · yayın") }}</small><strong data-landing-key="fixed.8">{{ landingText('fixed.8', "Sosyal medya") }}</strong></a>
            </div>
          }
        </div>
        <div class="system-view" aria-label="Aymudo işletme sistemi görselleştirmesi">
          <header>
            <span data-landing-key="fixed.9">{{ landingText('fixed.9', "AYMUDO / LIVE SYSTEM") }}</span><i></i><small data-landing-key="live">{{ copy().live }}</small>
          </header>
          <div class="system-core">
            <i data-landing-key="fixed.10">{{ landingText('fixed.10', "A") }}</i><strong data-landing-key="fixed.11">{{ landingText('fixed.11', "AYMUDO") }}</strong><small data-landing-key="oneCenter">{{ copy().oneCenter }}</small>
          </div>
          <div class="system-nodes">
            @for (node of copy().nodes; track node; let index = $index) {
              <span
                ><small>0{{ index + 1 }}</small
                >{{ node }}<i></i
              ></span>
            }
          </div>
          <footer>
            <span data-landing-key="connected">{{ copy().connected }}</span
            ><b>●</b>
          </footer>
        </div>
      </section>

      @if (i18n.contentLang() === 'tr') {
        <section [style.order]="sectionOrder('managed-services')" [style.display]="sectionHidden('managed-services') ? 'none' : null" data-landing-section="managed-services" class="managed-services" id="hizmetler">
          <header><p data-landing-key="fixed.12">{{ landingText('fixed.12', "İKİ AYRI YOL") }}</p><h2 data-landing-key="fixed.13">{{ landingText('fixed.13', "Yazılımı siz kullanın veya işi bize bırakın") }}</h2><span data-landing-key="fixed.14">{{ landingText('fixed.14', "Aymudo araçlarıyla operasyonunuzu kendiniz yönetin ya da müşteri mesajları, randevu talepleri, sosyal medya ve reklam işlerini ekibimizle birlikte yürütün.") }}</span></header>
          <div>
            <a routerLink="/hizmetler/uzaktan-sekreterlik"><small>01</small><h3 data-landing-key="fixed.15">{{ landingText('fixed.15', "Uzaktan sekreterlik") }}</h3><p data-landing-key="fixed.16">{{ landingText('fixed.16', "Müşteri iletişimini ve randevu taleplerini insan desteğiyle takip ediyoruz.") }}</p><b data-landing-key="fixed.17">{{ landingText('fixed.17', "Sekreterlik hizmetini incele →") }}</b></a>
            <a routerLink="/hizmetler/reklam-yonetimi"><small>02</small><h3 data-landing-key="fixed.18">{{ landingText('fixed.18', "Reklam yönetimi") }}</h3><p data-landing-key="fixed.19">{{ landingText('fixed.19', "Meta, Google ve uygun hesaplarda ChatGPT reklamlarını hedeflerinize göre yönetiyoruz.") }}</p><b data-landing-key="fixed.20">{{ landingText('fixed.20', "Reklam yönetimini incele →") }}</b></a>
            <a routerLink="/hizmetler/sosyal-medya-yonetimi"><small>03</small><h3 data-landing-key="fixed.21">{{ landingText('fixed.21', "Sosyal medya yönetimi") }}</h3><p data-landing-key="fixed.22">{{ landingText('fixed.22', "Hesaplarınızın içerik ve yayın sürecini yürütüyor, çekim ihtiyacını ayrıca planlıyoruz.") }}</p><b data-landing-key="fixed.23">{{ landingText('fixed.23', "Sosyal medya hizmetini incele →") }}</b></a>
            <a routerLink="/hizmetler/mesaj-cevaplama"><small>04</small><h3 data-landing-key="fixed.24">{{ landingText('fixed.24', "Mesaj cevaplama") }}</h3><p data-landing-key="fixed.25">{{ landingText('fixed.25', "WhatsApp, Instagram ve Facebook mesajlarına AI taslağı ve insan onayıyla cevap veriyoruz.") }}</p><b data-landing-key="fixed.26">{{ landingText('fixed.26', "Mesaj cevaplama hizmetini incele →") }}</b></a>
          </div><nav><a class="primary" routerLink="/hizmetler" data-landing-key="fixed.27">{{ landingText('fixed.27', "İşletmem için destek istiyorum") }}</a><a [routerLink]="i18n.routePath('products')" data-landing-key="fixed.28">{{ landingText('fixed.28', "Yazılım ürünlerini incele →") }}</a></nav>
        </section>
      }

      <section [style.order]="sectionOrder('ai-launch')" [style.display]="sectionHidden('ai-launch') ? 'none' : null" data-landing-section="ai-launch" class="ai-launch">
        <div class="ai-brands"><span class="aymudo-mini" data-landing-key="fixed.29">{{ landingText('fixed.29', "A") }}</span><strong data-landing-key="fixed.30">{{ landingText('fixed.30', "AYMUDO") }}</strong><i>+</i><img src="/brand/openai-mark.svg" alt="OpenAI" /><strong data-landing-key="fixed.31">{{ landingText('fixed.31', "OpenAI") }}</strong></div>
        <p data-landing-key="fixed.32">{{ landingText('fixed.32', "AYMO DESKTOP") }}</p>
        <h2 data-landing-key="aiTitleBefore">{{ copy().aiTitleBefore }} <em data-landing-key="fixed.33">{{ landingText('fixed.33', "GPT Astra") }}</em> {{ copy().aiTitleAfter }}</h2>
        <span data-landing-key="aiLead">{{ copy().aiLead }}</span>
        <div><a routerLink="/gpt-astra">{{ copy().aiDetail }} <b>→</b></a><a routerLink="/gpt-astra" fragment="indir">{{ copy().aiDownload }} <b>↓</b></a></div>
      </section>

      <section [style.order]="sectionOrder('aymo-callout')" [style.display]="sectionHidden('aymo-callout') ? 'none' : null" data-landing-section="aymo-callout" class="aymo-callout" aria-labelledby="aymo-callout-title">
        <div class="aymo-callout-copy">
          <p data-landing-key="aymoEyebrow">{{ copy().aymoEyebrow }}</p>
          <h2 id="aymo-callout-title" data-landing-key="aymoTitle">{{ copy().aymoTitle }}</h2>
          <span data-landing-key="aymoLead">{{ copy().aymoLead }}</span>
          <div>
            <a class="call-link" href="tel:+905074673035" aria-label="Aymo müşteri hizmetlerini ara">
              <i aria-hidden="true">☎</i><span><small data-landing-key="callNow">{{ copy().callNow }}</small><strong>+90 507 467 30 35</strong></span>
            </a>
            <a class="detail-link" routerLink="/aymo">{{ copy().discoverAymo }} <b>→</b></a>
          </div>
        </div>
        <div class="aymo-callout-signal">
          <span class="signal-ring signal-ring-one"></span>
          <span class="signal-ring signal-ring-two"></span>
          <span class="signal-ring signal-ring-three"></span>
          <div class="aymo-motion-stage"><app-aymo-motion state="listening" label="Aymo canlı ve dinliyor" /></div>
        </div>
      </section>

      <section [style.order]="sectionOrder('outcome-intro')" [style.display]="sectionHidden('outcome-intro') ? 'none' : null" data-landing-section="outcome-intro" class="outcome-intro">
        <p data-landing-key="promiseEyebrow">{{ copy().promiseEyebrow }}</p>
        <h2 data-landing-key="promiseTitle">{{ copy().promiseTitle }}</h2>
        <span data-landing-key="promiseLead">{{ copy().promiseLead }}</span>
      </section>

      <section [style.order]="sectionOrder('outcome-grid')" [style.display]="sectionHidden('outcome-grid') ? 'none' : null" data-landing-section="outcome-grid" class="outcome-grid">
        @for (item of copy().outcomes; track item.title; let index = $index) {
          <article>
            <span>0{{ index + 1 }}</span>
            <div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.text }}</p>
            </div>
            <a [routerLink]="homePath(item.path)">{{ copy().explore }} →</a>
          </article>
        }
      </section>

      <section [style.order]="sectionOrder('journey')" [style.display]="sectionHidden('journey') ? 'none' : null" data-landing-section="journey" class="journey">
        <header>
          <p data-landing-key="journeyEyebrow">{{ copy().journeyEyebrow }}</p>
          <h2 data-landing-key="journeyTitle">{{ copy().journeyTitle }}</h2>
          <span data-landing-key="journeyLead">{{ copy().journeyLead }}</span>
        </header>
        <div class="journey-flow">
          @for (step of copy().journeySteps; track step.title; let index = $index) {
            <article>
              <small>0{{ index + 1 }}</small>
              <i>{{ step.signal }}</i>
              <div>
                <h3>{{ step.title }}</h3>
                <p>{{ step.text }}</p>
              </div>
              <b>{{ index + 1 === copy().journeySteps.length ? '✓' : '→' }}</b>
            </article>
          }
        </div>
        <aside>
          <span data-landing-key="journeyResultEyebrow">{{ copy().journeyResultEyebrow }}</span>
          <strong data-landing-key="journeyResult">{{ copy().journeyResult }}</strong>
          <a [routerLink]="i18n.routePath('products')">{{ copy().journeyCta }} →</a>
        </aside>
      </section>

      <section [style.order]="sectionOrder('adaptation')" [style.display]="sectionHidden('adaptation') ? 'none' : null" data-landing-section="adaptation" class="adaptation">
        <header>
          <p data-landing-key="adaptEyebrow">{{ copy().adaptEyebrow }}</p>
          <h2 data-landing-key="adaptTitle">{{ copy().adaptTitle }}</h2>
          <span data-landing-key="adaptLead">{{ copy().adaptLead }}</span>
        </header>
        <div class="proof-grid">
          @for (item of proofs; track item.name; let index = $index) {
            <a
              [href]="item.url"
              target="_blank"
              rel="noopener"
              class="proof"
              [class.large]="index === 0"
            >
              <figure>
                <img
                  [src]="item.image"
                  [alt]="item.name + ' — Aymudo altyapısı'"
                  loading="lazy"
                  decoding="async"
                />
                <figcaption>
                  <span>{{ item.type }}</span
                  ><strong>{{ item.name }}</strong
                  ><b>↗</b>
                </figcaption>
              </figure>
            </a>
          }
        </div>
      </section>

      <section [style.order]="sectionOrder('capability-wall')" [style.display]="sectionHidden('capability-wall') ? 'none' : null" data-landing-section="capability-wall" class="capability-wall">
        <header>
          <p data-landing-key="modulesEyebrow">{{ copy().modulesEyebrow }}</p>
          <h2 data-landing-key="modulesTitle">{{ copy().modulesTitle }}</h2>
          <span data-landing-key="modulesLead">{{ copy().modulesLead }}</span>
        </header>
        <div class="capability-grid">
          @for (module of copy().modules; track module.title; let index = $index) {
            <article>
              <small>0{{ index + 1 }}</small>
              <h3>{{ module.title }}</h3>
              <p>{{ module.text }}</p>
              <b>{{ module.signal }}</b>
            </article>
          }
        </div>
        <a [routerLink]="i18n.routePath('products')">{{ copy().modulesCta }} →</a>
      </section>

      <section [style.order]="sectionOrder('operations')" [style.display]="sectionHidden('operations') ? 'none' : null" data-landing-section="operations" class="operations">
        <div class="operations-copy">
          <p data-landing-key="teamEyebrow">{{ copy().teamEyebrow }}</p>
          <h2 data-landing-key="teamTitle">{{ copy().teamTitle }}</h2>
          <span data-landing-key="teamLead">{{ copy().teamLead }}</span
          ><a [routerLink]="homePath('/urunler/sube-personel')">{{ copy().explore }} →</a>
        </div>
        <div class="permission-view" aria-hidden="true">
          <header><span data-landing-key="fixed.34">{{ landingText('fixed.34', "WORKSPACE / PERMISSIONS") }}</span><small data-landing-key="fixed.35">{{ landingText('fixed.35', "ACTIVE") }}</small></header>
          @for (role of copy().roles; track role.name) {
            <article>
              <i>{{ role.initial }}</i
              ><span
                ><strong>{{ role.name }}</strong
                ><small>{{ role.scope }}</small></span
              ><b>{{ role.access }}</b>
            </article>
          }
        </div>
      </section>

      <section [style.order]="sectionOrder('global')" [style.display]="sectionHidden('global') ? 'none' : null" data-landing-section="global" class="global">
        <header>
          <p data-landing-key="globalEyebrow">{{ copy().globalEyebrow }}</p>
          <h2 data-landing-key="globalTitle">{{ copy().globalTitle }}</h2>
          <span data-landing-key="globalLead">{{ copy().globalLead }}</span>
        </header>
        <div class="global-stats">
          <article>
            <strong>15</strong><span data-landing-key="languages">{{ copy().languages }}</span>
          </article>
          <article>
            <strong>≈30</strong><span data-landing-key="currencies">{{ copy().currencies }}</span>
          </article>
          <article>
            <strong data-landing-key="fixed.36">{{ landingText('fixed.36', "RTL") }}</strong><span data-landing-key="rtl">{{ copy().rtl }}</span>
          </article>
          <article>
            <strong data-landing-key="fixed.37">{{ landingText('fixed.37', "LIVE") }}</strong><span data-landing-key="rates">{{ copy().rates }}</span>
          </article>
        </div>
        <a [routerLink]="homePath('/urunler/global-satis')">{{ copy().globalCta }} →</a>
      </section>

      <section [style.order]="sectionOrder('closing')" [style.display]="sectionHidden('closing') ? 'none' : null" data-landing-section="closing" class="closing">
        <p data-landing-key="closeEyebrow">{{ copy().closeEyebrow }}</p>
        <h2 data-landing-key="closeTitle">{{ copy().closeTitle }}</h2>
        <div>
          <a class="primary" [routerLink]="i18n.routePath('subscribe')">{{ copy().subscribe }}</a
          ><a [routerLink]="i18n.routePath('pricing')">{{ copy().pricing }} →</a>
        </div>
      </section>
      <ng-container #extraHost />
    </main>
  `,
  styleUrl: './aymudo-modern-home.component.scss',
})
export class AymudoModernHomeComponent implements AfterViewInit, OnDestroy {
  protected readonly i18n = inject(I18nService);
  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly pageData = inject(PageDataService);
  private readonly pending=inject(PendingTasks);
  private readonly destroy=inject(DestroyRef);
  private readonly extraRef=signal<ComponentRef<any>|null>(null);
  @ViewChild('extraHost',{read:ViewContainerRef}) set extraHost(host:ViewContainerRef|undefined){
    if(!host||this.extraRef())return;
    void this.pending.run(async()=>{const module=await import('./aymudo-home-landing-sections.component');if(!this.destroy.destroyed)this.extraRef.set(host.createComponent(module.AymudoHomeLandingSectionsComponent));});
  }

  private readonly landing = signal<any>(this.seed().landing);
  protected readonly landingProducts=signal<any[]>(this.seed().products);
  private landingRevision=this.seed().revision;
  constructor(){effect(()=>{const ref=this.extraRef();if(ref){ref.setInput('sections',this.customSections());ref.setInput('faqs',this.landingFaqs());ref.setInput('products',this.landingProducts());}});effect(()=>{this.pageData.data();const seed=this.seed();if(seed.revision&&seed.revision!==this.landingRevision){this.landingRevision=seed.revision;this.landing.set(seed.landing);this.landingProducts.set(seed.products);}});}
  private seed():{landing:any;products:any[];revision:string}{const response=this.pageData.get<any>('aymudoLanding')??{};const data=response?.data??response??{};return {landing:data.landing??{texts:{},sections:[]},products:Array.isArray(data.products)?data.products:[],revision:String(data.landingRevision??'')};}
  protected customSections():any[]{return (this.landing().sections??[]).filter((section:any)=>section.type!=='core'&&section.removed!==true);}
  protected landingFaqs():any[]{return this.landing().faqPool??[];}
  protected landingText(key:string,fallback:string):string{return this.landing().texts?.[key]??fallback;}
  protected sectionOrder(key:string):number{const order=this.landing().sections?.findIndex((section:any)=>section.sectionKey===key)??-1;return order<0?HOME_SECTION_KEYS.indexOf(key):order;}
  protected sectionHidden(key:string):boolean{const section=this.landing().sections?.find((item:any)=>item.sectionKey===key);return section?.hidden===true||section?.removed===true;}
  protected readonly copy = computed(() => {
    const lang = this.i18n.contentLang();
    const base=structuredClone(COPY[lang] ?? { ...COPY['en'], ...(CORE_COPY[lang] ?? {}) });
    for(const [key,value] of Object.entries(this.landing().texts??{})){if(typeof value!=='string'||key.startsWith('fixed.'))continue;const parts=key.split('.');let target:any=base;for(const part of parts.slice(0,-1)){if(!Object.hasOwn(target,part)){target=null;break;}target=target[part];}const last=parts[parts.length-1];if(target&&Object.hasOwn(target,last)&&typeof target[last]==='string')target[last]=value;}
    return base;
  });
  protected homePath(path:string):string {
    const match=path.match(/^\/urunler\/([^/?#]+)/i);
    return match?`${this.i18n.routePath('products').replace(/\/+$/, '')}/${match[1]}`:this.i18n.localizedPath(path);
  }
  protected readonly proofs = [
    {
      name: 'CEON Dent',
      type: 'HEALTH / APPOINTMENT',
      url: 'https://www.ceondent.com',
      image: '/marketing/aymudo/screens/ceondent-desktop.webp',
    },
    {
      name: 'Umut Demir',
      type: 'SERVICE / TEAM',
      url: 'https://www.umutdemironline.com',
      image: '/marketing/aymudo/screens/umutdemir-desktop.webp',
    },
    {
      name: 'Fal Deryası',
      type: 'LIVE / MARKETPLACE',
      url: 'https://www.falderyasi.com',
      image: '/marketing/aymudo/screens/falderyasi-desktop.webp',
    },
    {
      name: 'BDSMBeds',
      type: 'GLOBAL / COMMERCE',
      url: 'https://www.bdsmbeds.com',
      image: '/marketing/aymudo/screens/bdsmbeds-desktop.webp',
    },
  ];
  private context?: { revert(): void };
  async ngAfterViewInit(): Promise<void> {
    if (
      typeof window === 'undefined' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    )
      return;
    const [{ gsap }, { ScrollTrigger }] = await Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger'),
    ]);
    gsap.registerPlugin(ScrollTrigger);
    this.context = gsap.context(() => {
      gsap.from('.hero-copy>*', {
        y: 22,
        stagger: 0.07,
        duration: 0.7,
        ease: 'power3.out',
        clearProps: 'transform',
      });
      gsap.from('.system-view', {
        y: 26,
        duration: 0.8,
        ease: 'power3.out',
        clearProps: 'transform',
      });
      gsap.utils
        .toArray<HTMLElement>(
          '.outcome-grid article,.journey-flow article,.proof,.capability-grid article,.permission-view article,.global-stats article',
        )
        .forEach((item) =>
          gsap.from(item, {
            y: 24,
            duration: 0.55,
            ease: 'power2.out',
            scrollTrigger: { trigger: item, start: 'top 92%', once: true },
            clearProps: 'transform',
          }),
        );
    }, this.host.nativeElement);
  }
  ngOnDestroy(): void {
    this.context?.revert();
  }
}

const COPY: Record<string, any> = {
  tr: {
    aiTitleBefore: 'İşletmeyi', aiTitleAfter: 'ile yönetin.',
    aiLead: 'Randevuları yöneten, sosyal mesajları cevaplayan, içerik yayınlayan, işletmenizi analiz eden ve izin verdiğiniz sitelerde sizinle birlikte çalışan AI Agent.',
    aiDetail: 'Detayları oku', aiDownload: "Desktop'ı indir",
    aymoEyebrow: 'AYMO MÜŞTERİ HİZMETLERİ / CANLI DEMO',
    aymoTitle: 'Bir müşteri gibi arayın. Aymo size cevap versin.',
    aymoLead: 'Çalışma saatlerini sorun, hizmetleri öğrenin veya randevu talebinizi söyleyin. Aymo işletme bilgisini kullanarak konuşmayı doğal biçimde sürdürür.',
    callNow: 'ŞİMDİ ARAYIN', discoverAymo: "Aymo'yu keşfedin",
    eyebrow: 'İşletmenin tamamı için tek altyapı',
    title: 'İşletmeniz için gereken sistem, baştan sona birlikte çalışır.',
    lead: 'Sitenizi kurun, ekibinizi yönetin, her kanaldan satış yapın. İşiniz büyüdüğünde kullandığınız sistemi değiştirmeyin.',
    subscribe: 'Aymudo’ya abone ol',
    discover: 'Neden Aymudo?',
    live: 'CANLI',
    oneCenter: 'Tek işletme merkezi',
    connected: 'Bütün modüller bağlı',
    nodes: ['Website', 'Randevu', 'Satış', 'Ekip', 'Stok', 'İletişim'],
    promiseEyebrow: 'Aymudo ile ne kazanırsınız?',
    promiseTitle: 'Ayrı araçları yönetmek yerine, işletmenizi yönetirsiniz.',
    promiseLead: 'Müşteri, çalışan, ürün, randevu ve satış aynı altyapıda aynı gerçeği kullanır.',
    explore: 'İncele',
    outcomes: [
      {
        title: 'Markanızı kurun',
        text: 'Yönetilebilir bir website ve işletmenize dönüşen tema sistemi.',
        path: '/themes',
      },
      {
        title: 'Operasyonu yönetin',
        text: 'Şube, personel, randevu, kaynak ve iletişim tek çalışma alanında.',
        path: '/urunler/sube-personel',
      },
      {
        title: 'Her yerde satın',
        text: 'Web, sosyal medya, pazaryeri, POS ve fiziksel mağaza aynı satış akışında.',
        path: '/commerce',
      },
      {
        title: 'Sınırları aşın',
        text: 'Dil, ülke, para birimi, depo ve kargo yapısıyla dünyaya açılın.',
        path: '/urunler/global-satis',
      },
    ],
    journeyEyebrow: 'Aymudo ile bir iş günü',
    journeyTitle: 'Müşterinin ilk hareketi, ekibin tamamladığı işe dönüşür.',
    journeyLead:
      'Satış, randevu veya mesaj fark etmez. Bilgi yeniden yazılmadan doğru kişiye, doğru ekrana ve doğru sonraki adıma ilerler.',
    journeySteps: [
      {
        signal: '01 / SIGNAL',
        title: 'Müşteri harekete geçer',
        text: 'Siteden randevu alır, ürün satın alır, form gönderir veya sosyal medyadan yazar.',
      },
      {
        signal: '02 / CONTEXT',
        title: 'Aymudo bağlamı birleştirir',
        text: 'Müşteri, şube, stok, hizmet, ödeme ve geçmiş bilgiler aynı işlemde buluşur.',
      },
      {
        signal: '03 / ACTION',
        title: 'Doğru ekip ekranına düşer',
        text: 'İş, yalnızca yetkili personelin kullanacağı ekrana görev ve bildirim olarak ulaşır.',
      },
      {
        signal: '04 / RESULT',
        title: 'Sonuç bütün sistemi günceller',
        text: 'Stok, takvim, kasa, müşteri geçmişi ve raporlar yapılan işin sonucunu birlikte görür.',
      },
    ],
    journeyResultEyebrow: 'Tekrar veri girişi yok',
    journeyResult:
      'Müşteri için kesintisiz deneyim, ekip için daha az hata, yönetim için güncel ve ölçülebilir bir işletme.',
    journeyCta: 'Birlikte çalışan ürünleri gör',
    adaptEyebrow: 'Tek kalıp değil',
    adaptTitle: 'Altyapı aynı kalır. Deneyim işletmeye dönüşür.',
    adaptLead:
      'Bir klinik, kuaför, canlı hizmet pazaryeri ve global mağaza birbirine benzemek zorunda değildir.',
    modulesEyebrow: 'Satışa dönüşen işletme araçları',
    modulesTitle: 'Müşteriyi tanıyın. Doğru anda yeniden kazanın.',
    modulesLead:
      'Aymudo yalnızca randevu ve satış kaydetmez; müşteri geçmişini, fırsatları ve ekibin yaptığı işi aynı profile bağlar.',
    modulesCta: 'Tüm ürünleri ve özellikleri gör',
    modules: [
      {
        title: 'Paket & sadakat',
        text: 'Hizmet paketleri, ziyaret kartları ve müşteri bakiyesi oluşturun; kullanımları müşteri profilinde izleyin.',
        signal: 'PROFILE / LOYALTY',
      },
      {
        title: 'Dijital müşteri hafızası',
        text: 'Geçmiş randevular, notlar, önce-sonra fotoğrafları, formüller ve kullanılan ürünler tek profilde kalır.',
        signal: 'MEMORY / HISTORY',
      },
      {
        title: 'Fırsat motoru',
        text: 'Sosyal mesajlardaki niyeti hizmetlerle eşleştirin; boş takvimi gerçek müşterilerle değerlendirin.',
        signal: 'INTENT / OPPORTUNITY',
      },
      {
        title: 'Kapora & ödeme',
        text: 'Kapora kuralını açın; havale veya Aymudo Mirror ile ödeme alın ve randevuyla birlikte takip edin.',
        signal: 'DEPOSIT / PAYMENT',
      },
      {
        title: 'Sosyal gelen kutusu',
        text: 'Mesaj, görsel, kişi, telefon ve konuşma niyetini tek gelen kutusunda yönetin.',
        signal: 'SOCIAL / INBOX',
      },
      {
        title: 'İçerik & reklam',
        text: 'Gönderi, Reels, video, carousel ve takvimi yönetin; reklamları ve performansı aynı ekrandan izleyin.',
        signal: 'CONTENT / GROWTH',
      },
      {
        title: 'Akıllı bildirimler',
        text: 'Yeni randevu, mesaj, yorum ve fırsatı yalnızca yetkili ekibe doğru çalışma alanıyla ulaştırın.',
        signal: 'REALTIME / ACTION',
      },
      {
        title: 'Dijital marka kimliği',
        text: 'Marka dili, görsel çizgi, logo, maskot ve referansları içerik üretimi için kalıcı hale getirin.',
        signal: 'BRAND / IDENTITY',
      },
    ],
    teamEyebrow: 'Ekip ve operasyon',
    teamTitle: 'Herkes yalnızca işini görür. Yönetim bütün resmi görür.',
    teamLead:
      'Personellere doğru ekranı ve yetkiyi verin. Tek staff kimliğiyle şubeler ve işletmeler arasında güvenle çalışın.',
    roles: [
      { initial: 'M', name: 'Merkez yönetim', scope: 'Tüm şubeler ve raporlar', access: 'FULL' },
      { initial: 'S', name: 'Şube yöneticisi', scope: 'Günlük operasyon', access: 'BRANCH' },
      { initial: 'P', name: 'Personel', scope: 'Atanan çalışma ekranı', access: 'ROLE' },
    ],
    globalEyebrow: 'Dünyaya açıl',
    globalTitle: 'Yeni ülke, yeni sistem demek değildir.',
    globalLead: 'Dil, fiyat, depo ve teslimat yapınız aynı merkezden her pazara uyarlanır.',
    languages: 'dil',
    currencies: 'para birimi',
    rtl: 'Arapça desteği',
    rates: 'güncel kur',
    globalCta: 'Global satış sistemini incele',
    closeEyebrow: 'İhtiyacınız olan yerden başlayın',
    closeTitle: 'Bugünkü işinize uyan, yarınınıza yetişen sistem.',
    pricing: 'Planları incele',
  },
  en: {
    aiTitleBefore: 'Manage your business with', aiTitleAfter: '.',
    aiLead: 'An AI agent that manages appointments, answers social messages, publishes content, analyses your business and works with you on authorised sites.',
    aiDetail: 'Read the details', aiDownload: 'Download Desktop',
    aymoEyebrow: 'AYMO CUSTOMER SERVICE / LIVE DEMO',
    aymoTitle: 'Call as a customer. Let Aymo answer.',
    aymoLead: 'Ask about opening hours, learn about services or request an appointment. Aymo uses business knowledge to continue the conversation naturally.',
    callNow: 'CALL NOW', discoverAymo: 'Explore Aymo',
    eyebrow: 'One infrastructure for the whole business',
    title: 'Everything your business needs, working together from end to end.',
    lead: 'Build your site, run your team and sell through every channel. Keep the same system as the business grows.',
    subscribe: 'Subscribe to Aymudo',
    discover: 'Why Aymudo?',
    live: 'LIVE',
    oneCenter: 'One business centre',
    connected: 'Every module connected',
    nodes: ['Website', 'Booking', 'Sales', 'Team', 'Inventory', 'Inbox'],
    promiseEyebrow: 'What do you gain with Aymudo?',
    promiseTitle: 'Manage the business, not a collection of disconnected tools.',
    promiseLead:
      'Customers, people, products, bookings and sales use the same truth on one infrastructure.',
    explore: 'Explore',
    outcomes: [
      {
        title: 'Build the brand',
        text: 'A manageable website and a theme system shaped around the business.',
        path: '/themes',
      },
      {
        title: 'Run operations',
        text: 'Branches, staff, bookings, resources and communication in one workspace.',
        path: '/urunler/sube-personel',
      },
      {
        title: 'Sell everywhere',
        text: 'Web, social, marketplace, POS and store sales in one flow.',
        path: '/commerce',
      },
      {
        title: 'Cross borders',
        text: 'Reach the world with language, country, currency, warehouse and shipping.',
        path: '/urunler/global-satis',
      },
    ],
    journeyEyebrow: 'A working day with Aymudo',
    journeyTitle: 'The customer’s first move becomes work the team can complete.',
    journeyLead:
      'Whether it is a sale, booking or message, context moves to the right person, workspace and next step without being entered again.',
    journeySteps: [
      {
        signal: '01 / SIGNAL',
        title: 'The customer takes action',
        text: 'They book, buy, submit a form or start a conversation through a social channel.',
      },
      {
        signal: '02 / CONTEXT',
        title: 'Aymudo connects the context',
        text: 'Customer, branch, inventory, service, payment and history become one operation.',
      },
      {
        signal: '03 / ACTION',
        title: 'The right workspace receives it',
        text: 'The task and notification reach only the people authorised to complete the work.',
      },
      {
        signal: '04 / RESULT',
        title: 'The result updates the system',
        text: 'Inventory, calendar, till, customer history and reporting reflect the completed work together.',
      },
    ],
    journeyResultEyebrow: 'No repeated data entry',
    journeyResult:
      'A continuous customer experience, fewer operational errors and a business management can measure in real time.',
    journeyCta: 'See connected products',
    adaptEyebrow: 'Not one template',
    adaptTitle: 'The infrastructure stays. The experience becomes the business.',
    adaptLead: 'A clinic, salon, live-service marketplace and global store should not look alike.',
    modulesEyebrow: 'Business tools that create revenue',
    modulesTitle: 'Know every customer. Win them back at the right moment.',
    modulesLead:
      'Aymudo does more than record bookings and sales: customer history, opportunities and completed work stay connected to one profile.',
    modulesCta: 'See every product and capability',
    modules: [
      {
        title: 'Packages & loyalty',
        text: 'Create service packages, visit rewards and customer credit; track every use on the customer profile.',
        signal: 'PROFILE / LOYALTY',
      },
      {
        title: 'Customer memory',
        text: 'Bookings, notes, before-and-after photos, formulas and products remain in one customer history.',
        signal: 'MEMORY / HISTORY',
      },
      {
        title: 'Opportunity engine',
        text: 'Match intent in social conversations to services and turn open calendar time into real demand.',
        signal: 'INTENT / OPPORTUNITY',
      },
      {
        title: 'Deposits & payments',
        text: 'Set deposit rules, accept bank transfer or Aymudo Mirror payments and track them with the booking.',
        signal: 'DEPOSIT / PAYMENT',
      },
      {
        title: 'Social inbox',
        text: 'Manage messages, media, contacts, phone numbers and conversation intent in one inbox.',
        signal: 'SOCIAL / INBOX',
      },
      {
        title: 'Content & advertising',
        text: 'Plan posts, Reels, video and carousels; manage campaigns and performance from one workspace.',
        signal: 'CONTENT / GROWTH',
      },
      {
        title: 'Actionable notifications',
        text: 'Deliver bookings, messages, reviews and opportunities to authorised people in the correct workspace.',
        signal: 'REALTIME / ACTION',
      },
      {
        title: 'Digital brand identity',
        text: 'Keep brand voice, visual rules, logo, mascot and references ready for consistent content production.',
        signal: 'BRAND / IDENTITY',
      },
    ],
    teamEyebrow: 'Team and operations',
    teamTitle: 'Everyone sees their work. Management sees the whole business.',
    teamLead:
      'Give each person the right workspace and permissions. Use one staff identity across branches and businesses.',
    roles: [
      {
        initial: 'M',
        name: 'Central management',
        scope: 'All branches and reporting',
        access: 'FULL',
      },
      { initial: 'B', name: 'Branch manager', scope: 'Daily operations', access: 'BRANCH' },
      { initial: 'S', name: 'Staff', scope: 'Assigned workspace', access: 'ROLE' },
    ],
    globalEyebrow: 'Go global',
    globalTitle: 'A new country does not require a new system.',
    globalLead: 'Adapt language, pricing, inventory and delivery to every market from one centre.',
    languages: 'languages',
    currencies: 'currencies',
    rtl: 'Arabic support',
    rates: 'live rates',
    globalCta: 'Explore global selling',
    closeEyebrow: 'Start where you need',
    closeTitle: 'A system for today, ready for tomorrow.',
    pricing: 'See plans',
  },
};

const CORE_COPY: Record<string, Record<string, string>> = {
  de: {
    eyebrow: 'Eine Infrastruktur für das ganze Unternehmen',
    title: 'Alles, was Ihr Unternehmen braucht, arbeitet durchgängig zusammen.',
    lead: 'Erstellen Sie Ihre Website, führen Sie Ihr Team und verkaufen Sie über jeden Kanal – mit einem System, das mitwächst.',
    subscribe: 'Aymudo abonnieren',
    discover: 'Warum Aymudo?',
    live: 'LIVE',
    oneCenter: 'Eine Unternehmenszentrale',
    connected: 'Alle Module verbunden',
    promiseEyebrow: 'Ihr Gewinn mit Aymudo',
    promiseTitle: 'Führen Sie Ihr Unternehmen, nicht eine Sammlung getrennter Tools.',
    promiseLead:
      'Kunden, Mitarbeiter, Produkte, Termine und Verkäufe arbeiten auf derselben Grundlage.',
    explore: 'Entdecken',
    adaptEyebrow: 'Keine Standardschablone',
    adaptTitle: 'Die Infrastruktur bleibt. Das Erlebnis wird zu Ihrem Unternehmen.',
    adaptLead: 'Klinik, Salon, Marktplatz und globaler Shop müssen nicht gleich aussehen.',
    teamEyebrow: 'Team und Betrieb',
    teamTitle: 'Jeder sieht seine Arbeit. Die Leitung sieht das Ganze.',
    teamLead: 'Geben Sie jeder Person den richtigen Arbeitsbereich und passende Berechtigungen.',
    globalEyebrow: 'Global wachsen',
    globalTitle: 'Ein neues Land braucht kein neues System.',
    globalLead: 'Passen Sie Sprache, Preise, Bestand und Lieferung zentral an jeden Markt an.',
    languages: 'Sprachen',
    currencies: 'Währungen',
    rtl: 'Arabisch & RTL',
    rates: 'Live-Kurse',
    globalCta: 'Globalen Verkauf entdecken',
    closeEyebrow: 'Starten Sie dort, wo Sie es brauchen',
    closeTitle: 'Ein System für heute, bereit für morgen.',
    pricing: 'Pläne ansehen',
  },
  es: {
    eyebrow: 'Una infraestructura para todo el negocio',
    title: 'Todo lo que tu negocio necesita funciona unido de principio a fin.',
    lead: 'Crea tu sitio, dirige a tu equipo y vende en todos los canales con un sistema que crece contigo.',
    subscribe: 'Suscríbete a Aymudo',
    discover: '¿Por qué Aymudo?',
    live: 'EN VIVO',
    oneCenter: 'Un único centro de negocio',
    connected: 'Todos los módulos conectados',
    promiseEyebrow: 'Lo que ganas con Aymudo',
    promiseTitle: 'Gestiona el negocio, no una colección de herramientas separadas.',
    promiseLead:
      'Clientes, equipo, productos, citas y ventas comparten una única fuente de verdad.',
    explore: 'Explorar',
    adaptEyebrow: 'No es una plantilla única',
    adaptTitle: 'La infraestructura permanece. La experiencia se convierte en tu negocio.',
    adaptLead: 'Una clínica, un salón, un marketplace y una tienda global no tienen que parecerse.',
    teamEyebrow: 'Equipo y operaciones',
    teamTitle: 'Cada persona ve su trabajo. La dirección ve todo el negocio.',
    teamLead: 'Asigna a cada persona el espacio y los permisos adecuados.',
    globalEyebrow: 'Vende en el mundo',
    globalTitle: 'Un nuevo país no exige un nuevo sistema.',
    globalLead: 'Adapta idioma, precios, inventario y entrega a cada mercado desde un solo centro.',
    languages: 'idiomas',
    currencies: 'monedas',
    rtl: 'árabe y RTL',
    rates: 'tipos en vivo',
    globalCta: 'Explorar ventas globales',
    closeEyebrow: 'Empieza donde lo necesites',
    closeTitle: 'Un sistema para hoy, preparado para mañana.',
    pricing: 'Ver planes',
  },
  fr: {
    eyebrow: 'Une infrastructure pour toute l’entreprise',
    title: 'Tout ce dont votre entreprise a besoin fonctionne ensemble, de bout en bout.',
    lead: 'Créez votre site, pilotez votre équipe et vendez sur tous les canaux avec un système qui évolue avec vous.',
    subscribe: 'S’abonner à Aymudo',
    discover: 'Pourquoi Aymudo ?',
    live: 'EN DIRECT',
    oneCenter: 'Un centre unique',
    connected: 'Tous les modules connectés',
    promiseEyebrow: 'Ce que vous gagnez avec Aymudo',
    promiseTitle: 'Gérez votre entreprise, pas une collection d’outils séparés.',
    promiseLead:
      'Clients, équipe, produits, rendez-vous et ventes partagent une même source de vérité.',
    explore: 'Découvrir',
    adaptEyebrow: 'Pas de modèle unique',
    adaptTitle: 'L’infrastructure reste. L’expérience devient votre entreprise.',
    adaptLead:
      'Une clinique, un salon, une marketplace et une boutique mondiale ne doivent pas se ressembler.',
    teamEyebrow: 'Équipe et opérations',
    teamTitle: 'Chacun voit son travail. La direction voit l’ensemble.',
    teamLead: 'Donnez à chaque personne le bon espace de travail et les bonnes autorisations.',
    globalEyebrow: 'Passez à l’international',
    globalTitle: 'Un nouveau pays ne nécessite pas un nouveau système.',
    globalLead: 'Adaptez langue, prix, stock et livraison à chaque marché depuis un seul centre.',
    languages: 'langues',
    currencies: 'devises',
    rtl: 'arabe et RTL',
    rates: 'taux en direct',
    globalCta: 'Découvrir la vente mondiale',
    closeEyebrow: 'Commencez là où vous en avez besoin',
    closeTitle: 'Un système pour aujourd’hui, prêt pour demain.',
    pricing: 'Voir les offres',
  },
  ar: {
    eyebrow: 'بنية واحدة لأعمالك بالكامل',
    title: 'كل ما يحتاجه عملك يعمل معاً من البداية إلى النهاية.',
    lead: 'أنشئ موقعك وأدر فريقك وبِع عبر كل القنوات ضمن نظام ينمو مع أعمالك.',
    subscribe: 'اشترك في أيمودو',
    discover: 'لماذا أيمودو؟',
    live: 'مباشر',
    oneCenter: 'مركز أعمال واحد',
    connected: 'جميع الوحدات متصلة',
    promiseEyebrow: 'ماذا تقدم لك أيمودو؟',
    promiseTitle: 'أدر عملك، لا مجموعة من الأدوات المنفصلة.',
    promiseLead: 'العملاء والموظفون والمنتجات والمواعيد والمبيعات يعملون على مصدر واحد للحقيقة.',
    explore: 'استكشف',
    adaptEyebrow: 'ليس قالباً واحداً',
    adaptTitle: 'تبقى البنية التحتية، وتصبح التجربة بهوية عملك.',
    adaptLead: 'لا يجب أن تتشابه العيادة والصالون والسوق والمتجر العالمي.',
    teamEyebrow: 'الفريق والعمليات',
    teamTitle: 'كل شخص يرى عمله، والإدارة ترى الصورة كاملة.',
    teamLead: 'امنح كل شخص مساحة العمل والصلاحيات المناسبة.',
    globalEyebrow: 'انطلق عالمياً',
    globalTitle: 'الدولة الجديدة لا تتطلب نظاماً جديداً.',
    globalLead: 'كيّف اللغة والأسعار والمخزون والتسليم لكل سوق من مركز واحد.',
    languages: 'لغة',
    currencies: 'عملة',
    rtl: 'العربية وRTL',
    rates: 'أسعار مباشرة',
    globalCta: 'استكشف البيع العالمي',
    closeEyebrow: 'ابدأ من حيث تحتاج',
    closeTitle: 'نظام لليوم، جاهز للغد.',
    pricing: 'عرض الخطط',
  },
  pt: {
    eyebrow: 'Uma infraestrutura para todo o negócio',
    title: 'Tudo o que sua empresa precisa funciona em conjunto, de ponta a ponta.',
    lead: 'Crie seu site, gerencie sua equipe e venda em todos os canais com um sistema que cresce junto.',
    subscribe: 'Assinar Aymudo',
    discover: 'Por que Aymudo?',
    live: 'AO VIVO',
    oneCenter: 'Um centro de negócios',
    connected: 'Todos os módulos conectados',
    promiseEyebrow: 'O que você ganha com Aymudo',
    promiseTitle: 'Gerencie o negócio, não uma coleção de ferramentas separadas.',
    promiseLead:
      'Clientes, equipe, produtos, agendamentos e vendas compartilham a mesma fonte de verdade.',
    explore: 'Explorar',
    adaptEyebrow: 'Não é um modelo único',
    adaptTitle: 'A infraestrutura permanece. A experiência se torna o seu negócio.',
    adaptLead: 'Clínica, salão, marketplace e loja global não precisam ser iguais.',
    teamEyebrow: 'Equipe e operações',
    teamTitle: 'Cada pessoa vê seu trabalho. A gestão vê o todo.',
    teamLead: 'Dê a cada pessoa o espaço de trabalho e as permissões certas.',
    globalEyebrow: 'Venda globalmente',
    globalTitle: 'Um novo país não exige um novo sistema.',
    globalLead: 'Adapte idioma, preços, estoque e entrega a cada mercado em um único centro.',
    languages: 'idiomas',
    currencies: 'moedas',
    rtl: 'árabe e RTL',
    rates: 'câmbio ao vivo',
    globalCta: 'Explorar vendas globais',
    closeEyebrow: 'Comece de onde precisa',
    closeTitle: 'Um sistema para hoje, pronto para amanhã.',
    pricing: 'Ver planos',
  },
  ru: {
    eyebrow: 'Единая инфраструктура для всего бизнеса',
    title: 'Всё, что нужно вашему бизнесу, работает вместе от начала до конца.',
    lead: 'Создайте сайт, управляйте командой и продавайте во всех каналах в системе, которая растёт вместе с вами.',
    subscribe: 'Подписаться на Aymudo',
    discover: 'Почему Aymudo?',
    live: 'В РЕАЛЬНОМ ВРЕМЕНИ',
    oneCenter: 'Единый центр бизнеса',
    connected: 'Все модули связаны',
    promiseEyebrow: 'Что даёт Aymudo',
    promiseTitle: 'Управляйте бизнесом, а не набором разрозненных инструментов.',
    promiseLead: 'Клиенты, команда, товары, записи и продажи используют единый источник данных.',
    explore: 'Подробнее',
    adaptEyebrow: 'Не один шаблон',
    adaptTitle: 'Инфраструктура остаётся. Опыт становится вашим бизнесом.',
    adaptLead: 'Клиника, салон, маркетплейс и глобальный магазин не должны выглядеть одинаково.',
    teamEyebrow: 'Команда и операции',
    teamTitle: 'Каждый видит свою работу. Руководство видит весь бизнес.',
    teamLead: 'Назначайте каждому подходящее рабочее пространство и права.',
    globalEyebrow: 'Выходите на мировой рынок',
    globalTitle: 'Новая страна не требует новой системы.',
    globalLead: 'Настраивайте язык, цены, склад и доставку для каждого рынка из одного центра.',
    languages: 'языков',
    currencies: 'валют',
    rtl: 'арабский и RTL',
    rates: 'актуальные курсы',
    globalCta: 'Глобальные продажи',
    closeEyebrow: 'Начните с нужного вам',
    closeTitle: 'Система для сегодня, готовая к завтра.',
    pricing: 'Смотреть тарифы',
  },
  zh: {
    eyebrow: '一套基础设施，覆盖整个企业',
    title: '企业所需的一切，从头到尾协同运行。',
    lead: '创建网站、管理团队并在所有渠道销售，系统会随业务一同成长。',
    subscribe: '订阅 Aymudo',
    discover: '为什么选择 Aymudo？',
    live: '实时',
    oneCenter: '一个业务中心',
    connected: '所有模块已连接',
    promiseEyebrow: 'Aymudo 为你带来什么',
    promiseTitle: '管理企业，而不是管理一堆彼此割裂的工具。',
    promiseLead: '客户、员工、产品、预约和销售共享同一事实来源。',
    explore: '探索',
    adaptEyebrow: '不止一种模板',
    adaptTitle: '基础设施保持一致，体验成为你的企业。',
    adaptLead: '诊所、沙龙、服务市场和全球商店无需千篇一律。',
    teamEyebrow: '团队与运营',
    teamTitle: '每个人专注自己的工作，管理者掌握全局。',
    teamLead: '为每个人提供合适的工作空间和权限。',
    globalEyebrow: '走向全球',
    globalTitle: '进入新国家，无需更换新系统。',
    globalLead: '从一个中心为每个市场调整语言、价格、库存和配送。',
    languages: '种语言',
    currencies: '种货币',
    rtl: '阿拉伯语与RTL',
    rates: '实时汇率',
    globalCta: '探索全球销售',
    closeEyebrow: '从你需要的地方开始',
    closeTitle: '满足今天，准备明天。',
    pricing: '查看方案',
  },
  hi: {
    eyebrow: 'पूरे व्यवसाय के लिए एक आधार',
    title: 'आपके व्यवसाय की हर जरूरत शुरू से अंत तक साथ काम करती है।',
    lead: 'अपनी साइट बनाएं, टीम चलाएं और हर चैनल पर बेचें—एक ऐसे सिस्टम के साथ जो आपके साथ बढ़े।',
    subscribe: 'Aymudo की सदस्यता लें',
    discover: 'Aymudo क्यों?',
    live: 'लाइव',
    oneCenter: 'एक व्यवसाय केंद्र',
    connected: 'सभी मॉड्यूल जुड़े हैं',
    promiseEyebrow: 'Aymudo से आपको क्या मिलता है',
    promiseTitle: 'अलग-अलग टूल नहीं, अपना व्यवसाय संभालें।',
    promiseLead: 'ग्राहक, टीम, उत्पाद, अपॉइंटमेंट और बिक्री एक ही सत्य का उपयोग करते हैं।',
    explore: 'देखें',
    adaptEyebrow: 'एक जैसा टेम्पलेट नहीं',
    adaptTitle: 'आधार वही रहता है। अनुभव आपका व्यवसाय बन जाता है।',
    adaptLead: 'क्लिनिक, सैलून, मार्केटप्लेस और वैश्विक स्टोर एक जैसे नहीं दिखने चाहिए।',
    teamEyebrow: 'टीम और संचालन',
    teamTitle: 'हर व्यक्ति अपना काम देखता है। प्रबंधन पूरी तस्वीर देखता है।',
    teamLead: 'हर व्यक्ति को सही कार्यक्षेत्र और अनुमति दें।',
    globalEyebrow: 'दुनिया भर में जाएं',
    globalTitle: 'नए देश के लिए नया सिस्टम जरूरी नहीं।',
    globalLead: 'एक केंद्र से हर बाजार के लिए भाषा, मूल्य, स्टॉक और डिलीवरी बदलें।',
    languages: 'भाषाएं',
    currencies: 'मुद्राएं',
    rtl: 'अरबी और RTL',
    rates: 'लाइव दरें',
    globalCta: 'वैश्विक बिक्री देखें',
    closeEyebrow: 'जहाँ जरूरत हो वहाँ से शुरू करें',
    closeTitle: 'आज के लिए सिस्टम, कल के लिए तैयार।',
    pricing: 'योजनाएं देखें',
  },
  ja: {
    eyebrow: '事業全体を支えるひとつの基盤',
    title: 'ビジネスに必要なすべてが、最初から最後まで連携します。',
    lead: 'サイトを作り、チームを動かし、すべてのチャネルで販売。成長しても同じシステムを使い続けられます。',
    subscribe: 'Aymudoを申し込む',
    discover: 'Aymudoを選ぶ理由',
    live: 'ライブ',
    oneCenter: 'ひとつの事業拠点',
    connected: 'すべてのモジュールが連携',
    promiseEyebrow: 'Aymudoで得られること',
    promiseTitle: '分断されたツールではなく、ビジネスそのものを管理。',
    promiseLead: '顧客、スタッフ、商品、予約、売上がひとつの正しい情報を共有します。',
    explore: '詳しく見る',
    adaptEyebrow: 'ひとつの型ではない',
    adaptTitle: '基盤は同じ。体験はあなたのビジネスになる。',
    adaptLead:
      'クリニック、サロン、マーケットプレイス、グローバルストアが同じ見た目である必要はありません。',
    teamEyebrow: 'チームと運営',
    teamTitle: '各自は自分の仕事を、経営は全体を見渡せます。',
    teamLead: '一人ひとりに適切なワークスペースと権限を設定できます。',
    globalEyebrow: '世界へ展開',
    globalTitle: '新しい国のために、新しいシステムは不要です。',
    globalLead: '言語、価格、在庫、配送をひとつの拠点から各市場に最適化。',
    languages: '言語',
    currencies: '通貨',
    rtl: 'アラビア語・RTL',
    rates: 'リアルタイム為替',
    globalCta: 'グローバル販売を見る',
    closeEyebrow: '必要な場所から始める',
    closeTitle: '今日に合い、明日に備えるシステム。',
    pricing: 'プランを見る',
  },
  ko: {
    eyebrow: '비즈니스 전체를 위한 하나의 기반',
    title: '비즈니스에 필요한 모든 것이 처음부터 끝까지 함께 작동합니다.',
    lead: '사이트를 만들고 팀을 운영하며 모든 채널에서 판매하세요. 성장해도 같은 시스템을 유지할 수 있습니다.',
    subscribe: 'Aymudo 구독하기',
    discover: 'Aymudo를 선택하는 이유',
    live: '실시간',
    oneCenter: '하나의 비즈니스 센터',
    connected: '모든 모듈 연결',
    promiseEyebrow: 'Aymudo로 얻는 것',
    promiseTitle: '서로 끊긴 도구가 아니라 비즈니스 자체를 관리하세요.',
    promiseLead: '고객, 팀, 상품, 예약과 판매가 하나의 정확한 정보를 공유합니다.',
    explore: '살펴보기',
    adaptEyebrow: '하나의 틀이 아닙니다',
    adaptTitle: '기반은 유지되고, 경험은 당신의 비즈니스가 됩니다.',
    adaptLead: '클리닉, 살롱, 마켓플레이스와 글로벌 스토어가 똑같을 필요는 없습니다.',
    teamEyebrow: '팀과 운영',
    teamTitle: '모두는 자신의 일을 보고, 경영진은 전체를 봅니다.',
    teamLead: '각 구성원에게 알맞은 작업 공간과 권한을 제공하세요.',
    globalEyebrow: '세계로 확장',
    globalTitle: '새로운 국가에 새로운 시스템은 필요 없습니다.',
    globalLead: '하나의 센터에서 시장별 언어, 가격, 재고와 배송을 조정하세요.',
    languages: '개 언어',
    currencies: '개 통화',
    rtl: '아랍어 및 RTL',
    rates: '실시간 환율',
    globalCta: '글로벌 판매 보기',
    closeEyebrow: '필요한 곳에서 시작하세요',
    closeTitle: '오늘에 맞고 내일을 준비하는 시스템.',
    pricing: '요금제 보기',
  },
  it: {
    eyebrow: 'Un’unica infrastruttura per tutta l’impresa',
    title: 'Tutto ciò che serve alla tua impresa lavora insieme, dall’inizio alla fine.',
    lead: 'Crea il sito, gestisci il team e vendi su ogni canale con un sistema che cresce con te.',
    subscribe: 'Abbonati ad Aymudo',
    discover: 'Perché Aymudo?',
    live: 'LIVE',
    oneCenter: 'Un solo centro operativo',
    connected: 'Tutti i moduli collegati',
    promiseEyebrow: 'Cosa ottieni con Aymudo',
    promiseTitle: 'Gestisci l’impresa, non una raccolta di strumenti separati.',
    promiseLead:
      'Clienti, team, prodotti, appuntamenti e vendite condividono un’unica fonte affidabile.',
    explore: 'Scopri',
    adaptEyebrow: 'Non un unico modello',
    adaptTitle: 'L’infrastruttura resta. L’esperienza diventa la tua impresa.',
    adaptLead: 'Clinica, salone, marketplace e negozio globale non devono assomigliarsi.',
    teamEyebrow: 'Team e operazioni',
    teamTitle: 'Ognuno vede il proprio lavoro. La direzione vede tutto.',
    teamLead: 'Assegna a ogni persona lo spazio di lavoro e i permessi corretti.',
    globalEyebrow: 'Apriti al mondo',
    globalTitle: 'Un nuovo paese non richiede un nuovo sistema.',
    globalLead: 'Adatta lingua, prezzi, inventario e consegna a ogni mercato da un solo centro.',
    languages: 'lingue',
    currencies: 'valute',
    rtl: 'arabo e RTL',
    rates: 'tassi live',
    globalCta: 'Scopri la vendita globale',
    closeEyebrow: 'Inizia da ciò che ti serve',
    closeTitle: 'Un sistema per oggi, pronto per domani.',
    pricing: 'Vedi i piani',
  },
  nl: {
    eyebrow: 'Eén infrastructuur voor het hele bedrijf',
    title: 'Alles wat uw bedrijf nodig heeft, werkt van begin tot eind samen.',
    lead: 'Bouw uw site, stuur uw team aan en verkoop via elk kanaal met een systeem dat meegroeit.',
    subscribe: 'Abonneer op Aymudo',
    discover: 'Waarom Aymudo?',
    live: 'LIVE',
    oneCenter: 'Eén bedrijfscentrum',
    connected: 'Alle modules verbonden',
    promiseEyebrow: 'Wat Aymudo u oplevert',
    promiseTitle: 'Beheer uw bedrijf, niet een verzameling losse tools.',
    promiseLead: 'Klanten, team, producten, afspraken en verkoop delen één betrouwbare bron.',
    explore: 'Ontdek',
    adaptEyebrow: 'Geen standaardmal',
    adaptTitle: 'De infrastructuur blijft. De ervaring wordt uw bedrijf.',
    adaptLead:
      'Een kliniek, salon, marktplaats en wereldwijde winkel hoeven niet op elkaar te lijken.',
    teamEyebrow: 'Team en operatie',
    teamTitle: 'Iedereen ziet het eigen werk. Het management ziet het geheel.',
    teamLead: 'Geef elke persoon de juiste werkruimte en bevoegdheden.',
    globalEyebrow: 'Ga wereldwijd',
    globalTitle: 'Een nieuw land vereist geen nieuw systeem.',
    globalLead: 'Pas taal, prijzen, voorraad en levering vanuit één centrum aan elke markt aan.',
    languages: 'talen',
    currencies: 'valuta',
    rtl: 'Arabisch en RTL',
    rates: 'live koersen',
    globalCta: 'Ontdek wereldwijd verkopen',
    closeEyebrow: 'Begin waar u het nodig hebt',
    closeTitle: 'Een systeem voor vandaag, klaar voor morgen.',
    pricing: 'Bekijk plannen',
  },
  id: {
    eyebrow: 'Satu infrastruktur untuk seluruh bisnis',
    title: 'Semua yang dibutuhkan bisnis Anda bekerja bersama dari awal hingga akhir.',
    lead: 'Bangun situs, kelola tim, dan jual di setiap kanal dengan sistem yang tumbuh bersama bisnis.',
    subscribe: 'Berlangganan Aymudo',
    discover: 'Mengapa Aymudo?',
    live: 'LANGSUNG',
    oneCenter: 'Satu pusat bisnis',
    connected: 'Semua modul terhubung',
    promiseEyebrow: 'Yang Anda dapatkan dengan Aymudo',
    promiseTitle: 'Kelola bisnis, bukan kumpulan alat yang terpisah.',
    promiseLead:
      'Pelanggan, tim, produk, janji temu, dan penjualan memakai satu sumber data yang sama.',
    explore: 'Jelajahi',
    adaptEyebrow: 'Bukan satu templat',
    adaptTitle: 'Infrastruktur tetap. Pengalaman menjadi bisnis Anda.',
    adaptLead: 'Klinik, salon, marketplace, dan toko global tidak harus terlihat sama.',
    teamEyebrow: 'Tim dan operasional',
    teamTitle: 'Setiap orang melihat pekerjaannya. Manajemen melihat keseluruhan.',
    teamLead: 'Berikan ruang kerja dan izin yang tepat kepada setiap orang.',
    globalEyebrow: 'Jangkau dunia',
    globalTitle: 'Negara baru tidak memerlukan sistem baru.',
    globalLead: 'Sesuaikan bahasa, harga, stok, dan pengiriman untuk setiap pasar dari satu pusat.',
    languages: 'bahasa',
    currencies: 'mata uang',
    rtl: 'Arab dan RTL',
    rates: 'kurs langsung',
    globalCta: 'Jelajahi penjualan global',
    closeEyebrow: 'Mulai dari yang Anda butuhkan',
    closeTitle: 'Sistem untuk hari ini, siap untuk esok.',
    pricing: 'Lihat paket',
  },
};

const HOME_SECTION_KEYS=["hero","managed-services","ai-launch","aymo-callout","outcome-intro","outcome-grid","journey","adaptation","capability-wall","operations","global","closing"];
